module.exports = __webpack_public_path__ + "img/burshtat_mob_portfolio_3.1b05e448.png";